/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCompositionApi from '@vue/composition-api'
import App from './App.vue'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// import './plugins/element.js'
// import VueSwal from 'vue-swal'
// Spinners
import CircleSpinner from './components/CircleSpinner'

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
// import 'element-ui/lib/theme-chalk/index.css';

// App setup
import router from './routes/router'
import store from './store'

import './registerServiceWorker'

Vue.filter('dp0', s => s ? Number.parseFloat(s).toFixed(0) : '')
Vue.filter('dp2', s => s ? Number.parseFloat(s).toFixed(2) : '')

// plugin setup
Vue.use(VueCompositionApi)
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(ElementUI, {locale})
// Vue.use(VueSwal)
Vue.component('circle-spinner', CircleSpinner)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router
})
